<script  lang="ts">
    import { service } from "@frontend/services";
    import { GetCachedToken } from "@frontend/user";
    import { ApiResultOfGroupDTO, ApiResultOfListOfGroupDTO, ApiResultOfPlayGroupDTO, ApiResultOfPublicUserDTO, EditGroupDTO, EditPlayGroupDTO, EditUserDTO, Group, PlayGroups, type User } from "@frontend/walletapi";
    import { translate, currentLanguage } from "../Translator";
    export let group: PlayGroups;
    export let dismiss: () => void;
  
    let result: ApiResultOfPlayGroupDTO | undefined = undefined;

    // Debug log al recibir el grupo
    console.log('EditGroupForm - Grupo recibido:', group);

    let editGroup: EditPlayGroupDTO = {
      Id: group.Id,
      Label: group.Label,
      GroupName: group.GroupName
    }

    // Debug log del objeto de edición
    console.log('EditGroupForm - Objeto de edición:', editGroup);
  
    async function EditGroup() {
      console.log('Intentando editar grupo:', editGroup);
      result = await service.walletapi.editPlayGroup({
          Token: GetCachedToken(),
          Data: editGroup
      });
      console.log('Resultado de edición:', result);
    }
  
  </script>
  
  
  <h2 class="ui centered dividing header">{$translate('Edit')}{editGroup.Id}</h2>
  {#if result && result.Success && result.Data}
      <div class="ui positive message">
          <div class="header">
              {editGroup.GroupName} {$translate('Edited successfully')}
          </div>
      </div>
  
      <div class="ui segment" style="display: flex;">
          <table class="receit-table" style="flex-grow: 1;">
              <tr>
                  <td class="receit-title">{$translate('Label')}</td>
                  <td class="receit-value">{result.Data.Label}</td>
              </tr>
              <tr>
                  <td class="receit-title">{$translate('Group Name')}</td>
                  <td class="receit-value">{result.Data.GroupName ?? ""}</td>
              </tr>
          </table>
      </div>
  
      <div style="display: flex; justify-content: center;">
          <button class="ui primary fluid button" on:click={dismiss}>Dismiss</button>
          <button class="ui fluid button">{$translate('Print')}</button>
      </div>
  {:else}
      {#if result && !result.Success}
          <div class="ui negative message">
              <div class="header">Error</div>
              <p>{result.ErrorMessage ?? `Unknown error when adding ${group.GroupName}`}</p>
          </div>
      {/if}
      <form class="ui positive form" on:submit|preventDefault={EditGroup}>
          <div class="field">
              <label>{$translate('Label')}
                  <input type="text" class="ui input" placeholder="First name..." bind:value={editGroup.Label}  required/>
              </label>
          </div>
          <div class="field">
              <label>{$translate('Group Name')}
                  <input type="text" class="ui input" placeholder="Last name..." bind:value={editGroup.GroupName}  required/>
              </label>
          </div>
          <div class="two field" style="display: flex">
              <button class="ui negative fluid button" on:click|preventDefault={dismiss}>{$translate('Cancel')}</button>
              <button class="ui positive fluid button">{$translate('Edit')} {group.GroupName}</button>
          </div>
      </form>
  {/if}
  
  <style>
      .receit-table
      {
          border-spacing: 0px;
          font-family: 'Courier New', Courier, monospace;
      }
  
      .receit-table td
      {
          padding-top: 5px;
      }
  
      .receit-table td:first-child
      {
          margin-right: 0.2em;
      }
  
      .receit-title
      {
          text-align: left;
          border-bottom: 1px solid black;
          padding-right: 10px;
      }
  
      .receit-value
      {
          text-align: right;
          border-bottom: 1px solid black;
      }
  </style>